import styled from "styled-components";
import {
  FlexContainer,
  FlexDiv,
  FlexSection,
  Box,
} from "../../../components/Atoms/Box";
import Button from "../../../components/Atoms/Button";
import StyledSvgSprite from "../../../components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";

export const Wrapper = styled(FlexSection)`
  padding: 56px 0 50px;
  background-color: ${({ theme }) => theme.colorsV2.shyft.cream};
  flex-direction: column;
`;
export const TopContainer = styled(FlexContainer)`
  flex-direction: column;
`;
export const BottomContainer = styled(TopContainer)`
  flex-direction: column;
  @media only screen and (max-width: 1023px) {
    padding: 0;
  }
`;

export const HeaderBox = styled(FlexDiv)`
  align-items: center;
  justify-content: space-between;
  padding: 2px 0;
  margin-bottom: 12px;
`;
export const Heading = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.blueGray.shade_700};
  max-width: 70%;
  width: 100%;
  @media only screen and (max-width: 359px) {
    max-width: 60%;
  }
`;
export const BrowseCta = styled(Button)``;

export const SliderWrapper = styled(Box)`
  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: auto !important;
  }
  .slick-list {
    padding: 30px 0;
  }
  .slick-slide {
    > div {
      display: flex;
      height: 100%;
      margin-right: 16px;
      @media only screen and (max-width: 1023px) {
        margin: 0 0px 0px 16px;
      }
    }
    &:last-child {
      > div {
        @media only screen and (max-width: 1023px) {
          margin: 0 16px 0px 16px;
        }
      }
    }
  }
`;
export const CardWrapper = styled(FlexDiv)`
  border: 1px solid ${({ theme }) => theme.colorsV2.gray.shade_200};
  padding: 24px;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  min-height: 240px;
  display: flex !important;
  flex-direction: column;
  * {
    position: relative;
    z-index: 2;
  }
  &::before {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 0;
    pointer-events: none;
    ${({ image }) =>
      image &&
      `
        background: url(${image}) no-repeat center;
        background-size: cover;
    `}
    background-color: ${({ theme }) => theme.colorsV2.gray.shade_500};
  }
  &:after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 1;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgba(${({ theme }) => theme.colors.shadows.black}, 0) 30%,
      rgba(${({ theme }) => theme.colors.shadows.black}, 0.6) 78.39%
    );
  }
  @media only screen and (max-width: 992px) {
    padding: 16px 8px;
  }
`;

export const SliderContainer = styled(FlexContainer)`
  @media only screen and (max-width: 1024px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
export const Text = styled(Typography)`
  @media only screen and (max-width: 1024px) {
    padding-left: 15px;
  }
`;
export const Description = styled(Typography)`
  .react-read-more-read-less {
    font-size: inherit;
    font-family: var(--font-700);
    color: ${({ theme }) => theme.colors.link2Color};
  }
`;
export const Rating = styled(Typography)`
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colorsV2.gray.shade_900}cc;
  padding: 4px 8px;
  border-radius: 24px;
  display: inline-flex;
  align-items: center;
`;
export const StarIcon = styled(StyledSvgSprite)`
  fill: ${({ theme }) => theme.colorsV2.warning.shade_400};
  height: 16px;
  width: 16px;
  margin-right: 2px;
`;
export const TopBox = styled(FlexDiv)`
  flex: 1;
  align-items: flex-start;
`;
export const BottomBox = styled(FlexDiv)`
  flex-direction: column;
  align-items: flex-start;
`;
export const TagBox = styled(FlexDiv)`
  align-items: center;
`;
export const Title = styled(Typography)`
  color: ${({ theme }) => theme.colors.white};
  padding: 8px;
`;
export const Tags = styled(Typography)`
  align-items: center;
  display: flex;
  color: ${({ theme }) => theme.colors.white};
  padding: 4px 8px;
  margin-right: 8px;
  background-color: ${({ theme }) => theme.colorsV2.gray.shade_900}99;
  border-radius: 24px;
  &:last-child {
    margin-right: 0;
  }
`;

export const CardLink = styled(Box)`
  cursor: pointer;
`;

export const RecipeItemContainer = styled(FlexDiv)`
  width: 100%;
  height: 240px;
  max-height: 240px;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  background-size: cover;
  background-repeat: no-repeat, no-repeat;
  border: 1px solid #e4e7ec;
  border-radius: 16px;
  overflow: hidden;
`;

export const ImageWrapper = styled(FlexDiv)`
  position: relative;
  height: 100%;
  width: 100%;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 30%,
      rgba(0, 0, 0, 0.6) 78.39%
    );
  }
`;

export const BottomTextContainer = styled(FlexDiv)`
  position: absolute;
  bottom: 24px;
  left: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const CookingTimeAndIngredientsContainer = styled(FlexDiv)`
  gap: 8px;
  align-items: center;
`;

export const RecipeTitle = styled(Typography)`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  align-items: center;
  color: #ffffff;
`;

export const Chip = styled(FlexDiv)`
  padding: 4px 8px;
  gap: 8px;
  background: rgba(16, 24, 40, 0.6);
  border-radius: 24px;
  align-items: center;
`;

export const ChipText = styled(Typography)`
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
`;

export const TopContainer2 = styled(FlexDiv)`
  position: absolute;
  top: 24px;
  left: 24px;
  right: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
